import styled from 'styled-components';
import { caption } from '@ardoq/typography';
import { colors, s4 } from '@ardoq/design-tokens';
import { ReferenceLinePreview, ReferenceLinePreviewProps } from '@ardoq/icons';
import { DecoratorWrapper } from './atoms';
import {
  ComponentDecorator,
  ComponentDecoratorProps,
} from './ComponentDecorator';
import { FlexBox } from '@ardoq/layout';

type ReferenceDecoratorProps = Pick<
  ReferenceLinePreviewProps,
  'lineBeginning' | 'lineEnding' | 'color' | 'line'
> & {
  referenceName: string;
  from?: ComponentDecoratorProps;
  to?: ComponentDecoratorProps;
};

const ReferenceName = styled.div`
  ${caption};
  color: ${colors.textModerate};
  display: inline-flex;
  align-items: center;
`;

// DRAFT, don't judge the css yet
const ReferencePreviewWrapper = styled(FlexBox)`
  position: relative;

  ${ReferenceName} {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    span {
      padding: ${s4};
      background-color: #fff;
    }
  }
`;

export const ReferenceDecorator = ({
  referenceName,
  lineBeginning,
  lineEnding,
  color,
  line,
  from,
  to,
}: ReferenceDecoratorProps) => (
  <DecoratorWrapper $skipIconColor>
    {from && <ComponentDecorator {...from} />}
    <ReferencePreviewWrapper>
      <ReferenceLinePreview
        lineBeginning={lineBeginning}
        lineEnding={lineEnding}
        width={200}
        color={color}
        line={line}
      />
      <ReferenceName>
        <span>{referenceName}</span>
      </ReferenceName>
    </ReferencePreviewWrapper>
    {to && <ComponentDecorator {...to} />}
  </DecoratorWrapper>
);
